import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import { Stack } from '@mui/system';
import { NavigationRounded } from '@mui/icons-material';

function CardListModal({ open, onClose, pack }) {

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{pack.pack_name}</DialogTitle>
            <DialogContent>
                <Typography fontSize="12px">Here are your preference cards that contain this pack:</Typography>
                {pack.cards && Object.entries(pack.cards).map(([hospital, cards]) => (
                    <Stack key={hospital} sx={{ pt: 2 }}>
                        <Typography variant="bold" sx={{ mb: 1, fontSize: '12px' }}>{hospital}:</Typography>
                        {cards.map(card => (
                            <Stack key={card.external_card_id} direction="row" alignItems="center" spacing={1} sx={{ pl: 2, py: 0.5, fontSize: '12px' }}>
                                <NavigationRounded sx={{ transform: 'rotate(90deg)', fontSize: '12px' }} />
                                <Typography variant="normal">{card.card_name}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                ))}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export default CardListModal;